// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Colors
 */
/**
 * Paddings, margins.
 */
/**
 *  Images
 */
/**
 * Fonts.
 */
/**
 * Mixins.
 */
.animate {
  -webkit-transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
  transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
}
.content__edit-topleft {
  background-color: #e6e6e6;
}
.content__edit-topleft input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
}
.content__edit-topleft > .tabs a {
  background-color: #a5a3a6;
  color: #000000;
  display: inline-block;
  padding: 10px;
  text-align: center;
}
.content__edit-topleft > .tabs a.active {
  background-color: #07bfea;
  color: #ffffff;
}
.content__edit-topleft > .tabs a:hover,
.content__edit-topleft > .tabs a:focus {
  text-decoration: none;
}
.content__edit-topleft > .tabContent {
  margin-bottom: 10px;
}
.content__edit-topleft > .tabContent form input {
  margin-bottom: 0;
}
.content__edit-topleft > .tabContent form .instructions {
  font-size: 80%;
  padding: 10px 0;
}
.content__edit-topleft > .tabContent form .instructions span {
  font-weight: bold;
}
.content__edit-topleft > .tabContent form .error {
  font-size: 80%;
  padding-top: 10px;
  color: #ff0000;
}
.content__edit-topleft > .tabContent form .error.question {
  float: right;
  text-align: right;
}
.content__edit-topleft > .tabContent .custom-picture__preview,
.content__edit-topleft > .tabContent .pictures__picture {
  max-width: 150px;
  max-height: 150px;
}
.content__edit-topleft .questions,
.content__edit-topleft .pictures {
  margin: 10px 0;
}
.content__edit-topleft .questions.pictures,
.content__edit-topleft .pictures.pictures {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-flow: row wrap;
          flex-flow: row wrap;
}
.content__edit-topleft .questions .questions__question,
.content__edit-topleft .pictures .questions__question,
.content__edit-topleft .questions .pictures__picture,
.content__edit-topleft .pictures .pictures__picture {
  text-align: center;
}
.content__edit-topleft .questions .questions__question.questions__question,
.content__edit-topleft .pictures .questions__question.questions__question,
.content__edit-topleft .questions .pictures__picture.questions__question,
.content__edit-topleft .pictures .pictures__picture.questions__question {
  padding: 10px;
}
.content__edit-topleft .questions .questions__question.pictures__picture,
.content__edit-topleft .pictures .questions__question.pictures__picture,
.content__edit-topleft .questions .pictures__picture.pictures__picture,
.content__edit-topleft .pictures .pictures__picture.pictures__picture {
  padding: 5px;
}
.content__edit-topleft .questions .questions__question.active,
.content__edit-topleft .pictures .questions__question.active,
.content__edit-topleft .questions .pictures__picture.active,
.content__edit-topleft .pictures .pictures__picture.active {
  background-color: #07bfea;
  border-color: #ffffff;
  color: #ffffff;
}
.content__edit-topleft .questions .questions__question:hover,
.content__edit-topleft .pictures .questions__question:hover,
.content__edit-topleft .questions .pictures__picture:hover,
.content__edit-topleft .pictures .pictures__picture:hover {
  cursor: pointer;
}
.content__edit-topright {
  background-color: #e6e6e6;
  text-align: center;
}
.content__edit-topright > button {
  float: right;
}
.content__edit-topright .preview {
  background-color: #ffffff;
  margin: auto;
  min-height: 200px;
  padding: 10px;
}
.content__edit-topright .preview img {
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/feature/edit/edit.less","webpack://./src/less/variables.less"],"names":[],"mappings":"AAAA;;EAEE;AACF;;EAEE;AACF;;EAEE;AACF;;EAEE;AACF;;EAEE;ACsBF;EACE,4DAAA;EAAA,oDAAA;ADpBF;AAfA;EACE,yBAAA;AAiBF;AAlBA;EAGI,WAAA;EACA,aAAA;EACA,mBAAA;AAkBJ;AAfE;EAEI,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;AAgBN;AAdM;EACE,yBAAA;EACA,cAAA;AAgBR;AAbM;;EACE,qBAAA;AAgBR;AAXE;EACE,mBAAA;AAaJ;AAdE;EAKM,gBAAA;AAYR;AAjBE;EASM,cAAA;EACA,eAAA;AAWR;AArBE;EAaQ,iBAAA;AAWV;AAxBE;EAkBM,cAAA;EACA,iBAAA;EACA,cAAA;AASR;AAPQ;EACE,YAAA;EACA,iBAAA;AASV;AAjCE;;EA+BI,gBAAA;EACA,iBAAA;AAMN;AAjEA;;EAgEI,cAAA;AAKJ;AAHI;;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,8BAAA;EAAA,6BAAA;MAAA,uBAAA;UAAA,mBAAA;AAMN;AA1EA;;;;EAgFM,kBAAA;AAAN;AARM;;;;EACE,aAAA;AAaR;AAVM;;;;EACE,YAAA;AAeR;AAVM;;;;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAeR;AAZM;;;;EACE,eAAA;AAiBR;AAXA;EAGE,yBAAA;EACA,kBAAA;AAWF;AAdE;EAAa,YAAA;AAiBf;AAlBA;EAOI,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AAcJ;AAxBA;EAaM,eAAA;AAcN","sourcesContent":["@import '../../less/variables';\n\n.content__edit-topleft {\n  background-color: @gray;\n  input {\n    width: 100%;\n    padding: @padding-btn;\n    margin-bottom: @margin-base;\n  }\n\n  & > .tabs {\n    a {\n      background-color: @gray-dark;\n      color: @black;\n      display: inline-block;\n      padding: @padding-btn;\n      text-align: center;\n\n      &.active {\n        background-color: @blue;\n        color: @white;\n      }\n\n      &:hover, &:focus {\n        text-decoration: none;\n      }\n    }\n  }\n\n  & > .tabContent {\n    margin-bottom: @margin-base;\n\n    form {\n      input {\n        margin-bottom: 0;\n      }\n\n      .instructions {\n        font-size: 80%;\n        padding: @padding-btn 0;\n\n        span {\n          font-weight: bold;\n        }\n      }\n\n      .error {\n        font-size: 80%;\n        padding-top: @padding-btn;\n        color: @error;\n\n        &.question {\n          float: right;\n          text-align: right;\n        }\n      }\n    }\n\n    .custom-picture__preview,\n    .pictures__picture {\n      max-width: @img-size-upload;\n      max-height: @img-size-upload;\n    }\n  }\n\n  .questions, .pictures {\n    margin: @margin-base 0;\n\n    &.pictures {\n      display: flex;\n      flex-flow: row wrap;\n    }\n\n    .questions__question, .pictures__picture {\n      &.questions__question {\n        padding: @padding-content * 2;\n      }\n\n      &.pictures__picture {\n        padding: @padding-content;\n      }\n\n      text-align: center;\n\n      &.active {\n        background-color: @blue;\n        border-color: @white;\n        color: @white;\n      }\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.content__edit-topright {\n  & > button { float: right; }\n\n  background-color: @gray;\n  text-align: center;\n\n  .preview {\n    background-color: @white;\n    margin: auto;\n    min-height: 200px;\n    padding: @padding-content * 2;\n\n    img {\n      max-width: 100%;\n    }\n  }\n}\n","/**\n * Colors\n */\n@black: rgb(0, 0, 0);\n@blue: rgb(7, 191, 234);\n@cream: rgb(250, 250, 250);\n@gray-dark: rgb(165, 163, 166);\n@gray: rgb(230, 230, 230);\n@gray-outline: rgb(217, 217, 217);\n@green-dark: rgb(63, 136, 41);\n@green: rgb(76, 169, 47);\n@white: rgb(255, 255, 255);\n@error: rgb(255, 0, 0);\n\n/**\n * Paddings, margins.\n */\n@padding-content: 5px;\n@padding-btn: 10px;\n@padding-navi-link: 10px;\n@margin-btn: 10px;\n@margin-base: 10px;\n\n/**\n *  Images\n */\n@img-size-upload: 150px;\n\n/**\n * Fonts.\n */\n@font-size-base: 1.6em;\n\n/**\n * Mixins.\n */\n.animate {\n  transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
